import styled from 'styled-components'
// @ts-ignore
import InputMask from 'react-input-mask'
import { colors } from 'Styled/variables'

export const InputContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: flex-start;
  margin-top: 16px;
`

// '!important' should be removed after all default css rules will be removed
export const Input = styled(InputMask)`
  padding: 13px 16px !important;
  width: 100% !important;
  height: 47px !important;
  font-size: 14px !important;
  line-height: 21px !important;
  color: ${colors.mainText} !important;
  border: 1px solid ${colors.greyStroke};
  border-radius: 8px;
`

export const Label = styled.span`
  margin-bottom: 8px;
  font-size: 14px;
  line-height: 21px;
  color: ${colors.mainText};
`

//  eslint-disable-next-line @typescript-eslint/no-explicit-any

export const Error = styled.span`
  color: ${colors.badgeRed};
`
